import axiosInstance from 'App/axios';
import {
  WithdrawalsPreferencesRequest,
  WithdrawalsPreferencesResponse,
} from 'commons/types/WithdrawsConfigType';

export const getWithdrawalsPreferences =
  async (): Promise<WithdrawalsPreferencesResponse> => {
    const response = await axiosInstance.get('/admin/preferences/withdrawals');
    return response.data;
  };

export const setWithdrawalsPreferences = async (
  request: WithdrawalsPreferencesRequest,
): Promise<void> => {
  await axiosInstance.patch('/admin/preferences/withdrawals', {
    ...request,
  });
};
